import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { MAINTENANCE_MODE_PATH } from '@core/maintenance/maintenance-mode.constants';
import { SiteStore } from '@core/site/site.store';

/**
 * Registered as canActivateChild (not canActivate) on the wrapping route in app.routes.ts.
 * Angular's default route-reuse strategy reuses that route's node across sibling
 * navigations, so a canActivate guard there would only run once, on first entry —
 * canActivateChild re-evaluates on every navigation to a route beneath it.
 */
export const maintenanceModeGuard: CanActivateChildFn = () => {
  const site = inject(SiteStore);
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  if (site.settings()?.maintenanceModeEnabled && !auth.isSuperAdmin()) {
    return router.createUrlTree([`/${MAINTENANCE_MODE_PATH}`]);
  }
  return true;
};
